export * from './src/stores-catalog-v3-product-products-v-3.schemas.js';
